import axios from "axios";

export default {
  CREATE_CONTRACT(context, { data }) {
    context.commit("CONTRACTS__UPDATE_LOADING", true);
    axios
      .post(`${context.getters.getUrl}/v1/Contracts`, data)
      .then((response) => {
        context.commit("CONTRACTS__REFRESH_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_LOADING", false);
      });
  },
  UPDATE_CONTRACT(context, { id, data }) {
    context.commit("CONTRACTS__UPDATE_LOADING", true);
    axios
      .put(`${context.getters.getUrl}/v1/Contracts/${id}`, data)
      .then((response) => {
        context.commit("CONTRACTS__REFRESH_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_LOADING", false);
      });
  },
  DELETE_CONTRACT(context, { id, language = 0 }) {
    context.commit("CONTRACTS__UPDATE_LOADING", true);
    context.commit("CONTRACTS__UPDATE_ITEM", undefined);
    axios
      .delete(`${context.getters.getUrl}/v1/Contracts/${id}`, {
        params: {
          language,
        },
      })
      .then((response) => {
        context.commit("CONTRACTS__REFRESH_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_LOADING", false);
      });
  },
  async GET_CONTRACT(context, { id, language = 0 }) {
    context.commit("CONTRACTS__UPDATE_LOADING", true);
    context.commit("CONTRACTS__UPDATE_ITEM", undefined);
    try {
      let response = await axios.get(
        `${context.getters.getUrl}/v1/Contracts/${id}`,
        {
          params: {
            language,
          },
        }
      );
      context.commit("CONTRACTS__UPDATE_ITEM", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      context.commit("CONTRACTS__UPDATE_LOADING", false);
    }
  },
  GET_CONTRACTS(context, payload) {
    context.commit("CONTRACTS__UPDATE_LIST_LOADING", true);
    context.commit("CONTRACTS__UPDATE_PAGE_NO", payload.page);
    context.commit("CONTRACTS__UPDATE_PAGE_SIZE", payload.count);
    axios
      .get(`${context.getters.getUrl}/v1/Contracts`, {
        params: {
          page: payload.page,
          count: payload.count,
          language: payload.language,
          phrase: payload.phrase,
          customerId: payload.customerId,
          projectId: payload.projectId,
        },
      })
      .then((response) => {
        context.commit("CONTRACTS__UPDATE_LIST", response.data.items);
        context.commit("CONTRACTS__UPDATE_TOTAL", response.data.count);
      })
      .catch((error) => {
        context.state.items = [];
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_LIST_LOADING", false);
      });
  },
  async GET_CONTRACT_GROUP(context, { id, language = 0 }) {
    context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", true);
    try {
      let response = await axios.get(
        `${context.getters.getUrl}/v1/ContractGroups/${id}`,
        {
          params: {
            language,
          },
        }
      );
      context.commit("CONTRACTS__UPDATE_ITEM", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", false);
    }
  },
  CREATE_CONTRACT_GROUP(context, { data }) {
    context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", true);
    axios
      .post(`${context.getters.getUrl}/v1/ContractGroups`, data)
      .then((response) => {
        context.commit("CONTRACTS__REFRESH_GROUPS_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", false);
      });
  },
  UPDATE_CONTRACT_GROUP(context, { id, data }) {
    context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", true);
    axios
      .put(`${context.getters.getUrl}/v1/ContractGroups/${id}`, data)
      .then((response) => {
        context.commit("CONTRACTS__REFRESH_GROUPS_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", false);
      });
  },
  DELETE_CONTRACT_GROUP(context, { id }) {
    context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", true);
    axios
      .delete(`${context.getters.getUrl}/v1/ContractGroups/${id}`)
      .then((response) => {
        context.commit("CONTRACTS__REFRESH_GROUPS_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_GROUPS_LOADING", false);
      });
  },
  GET_CONTRACT_GROUPS(context, payload) {
    context.commit("CONTRACTS__UPDATE_GROUPS_LIST_LOADING", true);
    context.commit("CONTRACTS__UPDATE_GROUPS_PAGE_NO", payload.page);
    context.commit("CONTRACTS__UPDATE_GROUPS_PAGE_SIZE", payload.count);
    axios
      .get(`${context.getters.getUrl}/v1/ContractGroups`, {
        params: {
          page: payload.page,
          count: payload.count,
          phrase: payload.phrase,
          language: payload.language,
        },
      })
      .then((response) => {
        context.commit("CONTRACTS__UPDATE_GROUPS_LIST", response.data.items);
        context.commit("CONTRACTS__UPDATE_GROUPS_TOTAL", response.data.count);
      })
      .catch((error) => {
        context.commit("CONTRACTS__UPDATE_GROUPS_LIST", []);
        console.log(error);
      })
      .finally(() => {
        context.commit("CONTRACTS__UPDATE_GROUPS_LIST_LOADING", false);
      });
  },
};
